import React from "react";

import { TournamentOffer } from "@gp/offer";

import { TournamentEventsList } from "./TournamentEventsList";

export function TournamentBody(props: {
	tournament: TournamentOffer;
	hidden: boolean;
}) {
	if (props.hidden) {
		return null;
	}

	return (
		<div className="offer__body">
			<TournamentEventsList tournament={props.tournament} />
		</div>
	);
}
